/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 01.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import Breadcrumb from "./Breadcrumb";
import ActionButtons from "./ActionButtons";

class PageTitle extends React.Component {
    static propTypes = {
        /**
         * Page title
         */
        title: PropTypes.string,
        /**
         * Breadcrumb links. Last item will be shown without link
         */
        breadcrumb: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            to: PropTypes.string
        })).isRequired,
        /**
         * Actions
         */
        actions: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.node,
            action: PropTypes.string.isRequired
        })),
        /**
         * @type {OnActionCallback}
         */
        onAction: PropTypes.func,
        location: PropTypes.object
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="row wrapper border-bottom white-bg page-heading">
                <div className="col-lg-12">
                    <h2>{this.props.title}</h2>
                    <Breadcrumb links={this.props.breadcrumb}/>
                    <div className="page-actions">
                        <ActionButtons actions={this.props.actions} onAction={this.props.onAction} location={this.props.location}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default PageTitle;